import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';

type State = {
  selections: Record<string, string[]>;
};

const initialState: State = { selections: {} };

const groupChangeSubResourcesSlice = createSlice({
  name: 'groupChangeSubResources',
  initialState,
  reducers: {
    setSubResources(
      state,
      action: PayloadAction<{ key: string; ids: string[] }>
    ) {
      const { key, ids } = action.payload;
      state.selections[key] = ids;
    },
    clearForRequest(state, action: PayloadAction<string>) {
      const prefix = `${action.payload}:`;
      for (const key of Object.keys(state.selections)) {
        if (key.startsWith(prefix)) {
          delete state.selections[key];
        }
      }
    },
  },
});

export const { setSubResources, clearForRequest } =
  groupChangeSubResourcesSlice.actions;

export const selectSubResourceIds = (state: RootState, key: string): string[] =>
  state.groupChangeSubResources.selections[key] ?? [];

export const hasSubResourceKey = (state: RootState, key: string): boolean =>
  key in state.groupChangeSubResources.selections;

export default groupChangeSubResourcesSlice.reducer;
